import React from 'react';
import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemType } from '@src/framework/workbench/drawer/constants';
import { config as addConfig } from '@framework/workbench/ui/group/add-group/config';
import { config as removeConfig } from '@framework/workbench/ui/group/remove-group/config';
import { ADD_GROUP_ICON, REMOVE_GROUP_ICON } from '@src/framework/workbench/drawer/image';
import Style from '@framework/workbench/drawer/ui/index.less';
import { COMMON_STYLE } from '@framework/workbench/drawer/common/config';

const GROUP_STYLE = {
    ...COMMON_STYLE,
    minWidth: 116,
};

export const FORM_CONFIGS_ADDGROUP: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: addConfig.id,
        options: {
            icon: <img src={ADD_GROUP_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: GROUP_STYLE,
        tooltip: addConfig.content,
    },
];

export const FORM_CONFIGS_REMOVEGROUP: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: removeConfig.id,
        options: {
            icon: <img src={REMOVE_GROUP_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        style: GROUP_STYLE,
        tooltip: removeConfig.content,
    },
];
